import { useMutation } from '@tanstack/react-query';

import Api from '@/controllers/api';
import type { MutationHook } from '@/lib/react-query/react-query-types';

import type {
  CreateWorkerQualificationRequest,
  CreateWorkerQualificationResponse,
  UpdateWorkerQualificationRequest,
  UpdateWorkerQualificationResponse,
} from './types';

//*--------------------------------------------------------------------------------

export const useCreateWorkerQualification: MutationHook<
  CreateWorkerQualificationRequest,
  CreateWorkerQualificationResponse
> = ({ ...mutationHookParams }) => {
  return useMutation({
    ...mutationHookParams,
    mutationFn: (params) => {
      return Api.post('/worker-qualification', params);
    },
  });
};

//*--------------------------------------------------------------------------------

export const useUpdateWorkerQualification: MutationHook<
  UpdateWorkerQualificationRequest,
  UpdateWorkerQualificationResponse
> = ({ ...mutationHookParams }) => {
  return useMutation({
    ...mutationHookParams,
    mutationFn: ({ workerId, ...params }) => {
      return Api.patch(`/worker-qualification/${workerId}`, params);
    },
  });
};
